import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

import _actions from '../actions';

import './Debug.scss';

class DebugContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false
    };
  }

  shareUrl() {
    const { fullState } = this.props;
    const json = encodeURIComponent(JSON.stringify(fullState));

    var url = window.location.href;
    var delim = '?';
    if (url.indexOf('?') > 0) {
      delim = '&';
    }

    url = `${url}${delim}state=${json}`;
    console.log(url); // eslint-disable-line
    alert('Link logged to console');
  }

  render() {
    return (
      <div className="flex flex-column Debug no-print">
        <div className="pl3 pr3 pb3">
          <button
            onClick={() => {
              this.setState({ visible: !this.state.visible });
            }}
          >
            {this.state.visible ? 'Hide debug info' : 'Show debug info'}
          </button>
        </div>

        <div
          className="pl3 pr3 pb3"
          style={{ display: this.state.visible ? 'block' : 'none' }}
        >
          <a href="https://www.google.com">Link to Google</a>
          <button
            onClick={() => {
              this.shareUrl();
            }}
          >
            Share URL
          </button>
          <pre className="DebugContainer theme-code">
            <code>{JSON.stringify(this.props, null, 2)}</code>
          </pre>
        </div>
      </div>
    );
  }
}

DebugContainer.propTypes = {
  fullState: PropTypes.object
};

const mapStateToProps = state => ({
  ...state,
  fullState: state
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(_actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DebugContainer));
